import { FileText, Phone } from "lucide-react";
import { useSEO } from "@/lib/seo";
import { PAGE_META } from "@/data/page_meta";

import { CONTACT, BUSINESS_NAME } from "@/data/site";

export default function TermsPage() {
  useSEO(PAGE_META.terms);

  return (
    <div className="min-h-screen bg-muted/30 pt-32 pb-24" data-testid="terms-page">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <span className="w-14 h-14 rounded-full bg-leaf/15 flex items-center justify-center mb-6"><FileText className="w-7 h-7 text-leaf" /></span>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-navy">Terms of Service</h1>
        <p className="mt-5 text-muted-foreground">
          Our full terms of service and cancellation policy are being finalized. In the meantime,
          here is a quick summary of how we work at {BUSINESS_NAME}.
        </p>

        <div className="mt-8 space-y-6 text-navy">
          <section>
            <h2 className="font-heading text-lg font-semibold">Booking & deposits</h2>
            <p className="mt-2 text-muted-foreground">A refundable $50 deposit secures your appointment on bookings over $200 and is applied to your final total. Your final price is confirmed after we review the details of your space.</p>
          </section>
          <section>
            <h2 className="font-heading text-lg font-semibold">Rescheduling & cancellations</h2>
            <p className="mt-2 text-muted-foreground">Need to change your appointment? Just let us know ahead of time and we'll find a new slot that works for you.</p>
          </section>
          <section>
            <h2 className="font-heading text-lg font-semibold">Our 24-hour guarantee</h2>
            <p className="mt-2 text-muted-foreground">If we miss something, tell us within 24 hours of your clean and we'll return to make it right at no cost.</p>
          </section>
        </div>

        <div className="mt-10 rounded-2xl border border-border bg-white p-5 flex items-center gap-3">
          <Phone className="w-5 h-5 text-leaf" />
          <p className="text-sm text-navy">Questions about our terms? Call us at <a href={CONTACT.phoneHref} className="text-leaf font-medium">{CONTACT.phone}</a>.</p>
        </div>
      </div>
    </div>
  );
}
